"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sort = void 0;
function sort(cmp, ts) {
    var sorter = function (ts) {
        return ts
            .map(function (t, i) { return ({ index: i, value: t }); })
            .sort(function (a, b) { return cmp(a.value, b.value) || a.index - b.index; })
            .map(function (_a) {
            var value = _a.value;
            return value;
        });
    };
    return typeof ts === "undefined" ? sorter : sorter(ts);
}
exports.sort = sort;
